(function () {
  lgkorUI.showAppBottomMenuOver(true); //앱 덮는식으로 변경
  function init() {
    $(".subpage, .mainpage").each(function () { //BTOCSITE-20911 [매장홈페이지] 메인 홈 UI 재 구성 요청(매장 키비주얼 개선 건)
      var $this = $(this);
      var infohead = $this.find(".officehome_infohead");
      //매장안내 페이지
      $this.find(".officehome_map .map_apt").each(function () {
        var $this = $(this);
        vcui.require(["ui/storeMap"], function () {
          var mapId = $this.data("mapId");
          var appkey = $this.data("appKey");
          var latitude = $this.data("latitude");
          var longitude = $this.data("longitude");
          var shopname = $this.data("shopName");
          var searchRoadUrl;

          if (vcui.detect.isMobile) {
            searchRoadUrl =
              "https://m.map.naver.com/route.nhn?ex=" +
              longitude +
              "&ey=" +
              latitude +
              "&ename=LG전자 " +
              shopname +
              "&menu=route&pathType=1";
          } else {
            searchRoadUrl =
              "https://map.naver.com/index.nhn?elng=" +
              longitude +
              "&elat=" +
              latitude +
              "&etext=LG전자 " +
              shopname +
              "&menu=route&pathType=1";
          }

          $this
            .vcStoreMap({
              keyID: mapId,
              appKey: appkey,
              longitude: longitude,
              latitude: latitude,
            })
            .on("maploaded", function (e, data) {
              var map = $this.vcStoreMap("instance");
              map.addMaker(latitude, longitude);
              // start 20220602 LGECOMVIO-41 매장안내 지도영역 이동 타이밍 수정
              if (lgkorUI.getParameterByName("mapMove") === "1") {
                $(".toolbar_item.locate a").click();
              }
              // end 20220602 LGECOMVIO-41 매장안내 지도영역 이동 타이밍 수정
            });
          $(".map_findway > a").each(function () {
            var $this = $(this);
            $this.on("click", function (e) {
              window.open(encodeURI(searchRoadUrl));
            });
          });
        });
      });

      //복사하기
      $this.find(".adress_copy").each(function () {
        var $this = $(this);
        $this.on("click", function () {
          var $this = $(this);
          var txt = $this.prev(".adress_body").text();
          var tit = $this.prevAll(".adress_head").text();
          vcui.dom.copyToClipboard(txt, {
            onSuccess: function () {
              $(window).trigger("toastshow", tit + "을 복사했습니다.");
            },
          });
        });
      });

      var AppLink = {
        aosUrl:
          "intent://scan/#Intent;scheme=kakaomap;package=net.daum.android.map;end",
        iosUrl: "http://itunes.apple.com/app/id304608425",
        customSchemeMain: "kakaomap://", //수정 2021.07.06
        googlePlayUrl:
          "https://play.google.com/store/apps/details?id=net.daum.android.map",
        isIPHONE:
          navigator.userAgent.match("iPhone") != null ||
          navigator.userAgent.match("iPod") != null,
        isIPAD: navigator.userAgent.match("iPad") != null,
        isANDROID: navigator.userAgent.match("Android") != null,
        isMobile: function () {
          if (AppLink.isANDROID || AppLink.isIPHONE || AppLink.isIPAD) {
            return true;
          } else {
            alert("모바일 환경에서만 동작합니다.");
            return false;
          }
        },
        installApp: function () {
          if (AppLink.isIPHONE || AppLink.isIPAD) {
            // 2019-03-22 timer
            AppLink.iosLink();
          } else if (AppLink.isANDROID) {
            AppLink.androidIntent(AppLink.aosUrl);
          }
        },
        executeApp: function (url) {
          if (AppLink.isIPHONE || AppLink.isIPAD) {
            location.href = url;
          } else if (AppLink.isANDROID) {
            AppLink.androidCustomScheme(url);
          }
        },
        ios: function () {
          AppLink.iosLink();

          location.href = AppLink.customSchemeMain; //앱이동
        },
        /**
         * ios 마켓 링크 이동
         */
        iosLink: function () {
          var clickedAt = +new Date();
          setTimeout(function () {
            if (+new Date() - clickedAt < 2000) {
              location.href = AppLink.iosUrl;
            }
          }, 1500);
        },
        androidIntent: function (url) {
          var b = new Date();
          setTimeout(function () {
            if (new Date() - b < 1500) {
              location.href = url;
            }
          }, 500);
        },
        /**
         * android 커스텀스킴 이동
         */
        androidCustomScheme: function (customScheme) {
          if (isApp()) {
            var iframe = document.createElement("iframe");
            iframe.style.visibility = "hidden";
            iframe.src = customScheme;
            document.body.appendChild(iframe);
            document.body.removeChild(iframe); // back 호출시 캐싱될 수 있으므로 제거
          } else {
            window.location.href = customScheme; //앱이동
          }
        },
        android: function () {
          if (AppLink.isANDROID || AppLink.isIPHONE || AppLink.isIPAD) {
            AppLink.androidIntent(AppLink.aosUrl);
            AppLink.androidCustomScheme(AppLink.customSchemeMain);
          } else {
            location.href = AppLink.googlePlayUrl;
          }
        },
        appMove: function (customScheme, isAppMove) {
          if (!customScheme) {
            //main 이동
            customScheme = AppLink.customSchemeMain;
          }

          // 바로 앱 이동일 경우
          if (isAppMove) {
            if (AppLink.isANDROID) {
              AppLink.androidIntent(AppLink.aosUrl);
            }
            AppLink.executeApp(customScheme);
          } else {
            if (!AppLink.isMobile()) return;
            AppLink.installApp(); //app move
            AppLink.executeApp(customScheme);
          }
        },
      };

      //지도 앱
      $(".map_kakao, .map_naver").each(function () {
        var $this = $(this);
        $this.on("click", function () {
          var latitude = $this.data("latitude");
          var longitude = $this.data("longitude");
          var name = $this.data("name");

          if ($this.hasClass("map_kakao")) {
            //카카오
            AppLink.appMove(
              "kakaomap://route?ep=" +
                latitude +
                "," +
                longitude +
                "&by=PUBLICTRANSIT"
            );
          } else {
            //네이버
            if (vcui.detect.isIOS) {
              var clickedAt = +new Date();
              location.href =
                "nmap://route/public?dlat=" +
                latitude +
                "&dlng=" +
                longitude +
                "&dname=" +
                name +
                "&appname=com.example.myapp";
              setTimeout(function () {
                if (+new Date() - clickedAt < 2000) {
                  location.href =
                    "http://itunes.apple.com/app/id311867728?mt=8";
                }
              }, 1500);
            } else if (vcui.detect.isAndroid) {
              var b = new Date();
              setTimeout(function () {
                if (new Date() - b < 1500) {
                  location.href =
                    "intent://scan/#Intent;scheme=nmap;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.nmap;end";
                }
              }, 500);
              if (isApp()) {
                var iframe = document.createElement("iframe");
                iframe.style.visibility = "hidden";
                iframe.src =
                  "nmap://route/public?dlat=" +
                  latitude +
                  "&dlng=" +
                  longitude +
                  "&dname=" +
                  name +
                  "&appname=com.example.myapp";
                document.body.appendChild(iframe);
                document.body.removeChild(iframe); // back 호출시 캐싱될 수 있으므로 제거
              } else {
                location.href =
                  "nmap://route/public?dlat=" +
                  latitude +
                  "&dlng=" +
                  longitude +
                  "&dname=" +
                  name +
                  "&appname=com.example.myapp";
              }
            }
          }
        });
      });

      //베스트샵 지점별 홈페이지 2차 영업 안내 제품위치 보기 20220905 start
      var bestZoneFlag = $this.data("bestZoneFlag") || 1;
      if (bestZoneFlag && (vcui.detect.isIOS || vcui.detect.isAndroid)) {
        var depth2 = $this.find(".officehome_productmenu");
        var shopinfo = $this.find(".officehome_shopinfo");
        depth2.addClass("appear");
        depth2.find(".tabs > li:eq(1) > a").on("click", function (e) {
          e.preventDefault();
          var $this = $(e.currentTarget);
          var url = $this.data("url") || "www.naver.com";

          location.href = vcui.uri.updateQueryParam(
            url,
            "referrer",
            "bestshop"
          );
        });
      }
      //베스트샵 지점별 홈페이지 2차 영업 안내 제품위치 보기 20220905 end
    });
  }

  function checkStoremode() {
    var pathSplit = location.pathname.split("-");
    var strShopId = "";
    if(pathSplit.length > 1) {
      strShopId = pathSplit[1];
    }
    if(strShopId) {
      var ajaxUrl = "/bestshop/bestshopInfo.lgajax?shopId=" + strShopId;
      lgkorUI.requestAjaxDataPost(ajaxUrl, {}, function (result) {
        var data = result.shopInfo;
        if (data) {
          if (data.storeViewFlag != "Y") {
            var obj = {
              title: '.', ok: function () {
                window.location.href = "/bestshop/store-finder";
              }
            };
            var desc = '';
            obj = $.extend(obj, {title: '종료된 매장으로 매장정보를 찾을 수 없습니다.'});
            lgkorUI.alert(desc, obj);
          }
        }
      });
    }
  }

  $(document).ready(function () {
    init();
    vcui.require(["customer/bestShopModule/common"]);

    checkStoremode();
  });
})();
